/**
 * Central export of all table definitions.
 *
 * This file exports only the table schema definitions (no mutators)
 * to allow schema.ts to build the zql builder without circular imports.
 */

import { habitNutritionFood } from "./habit-nutrition-food/table";

export const allTables = [habitNutritionFood] as const;
